import api from '@/api/panel-api';
/**
 */
class PanelApiIadea {
  accessToken;

  /**
   * @return {Promise<void>}
   */
  async goHomeRetry() {
    try {
      return await this.goHome();
    } catch (e) {}
    // retry in case its auth
    await this.updateAuthToken();
    await this.goHome();
  }

  /**
   * @return {Promise<void>}
   */
  async goHome() {
    if (!this.accessToken) {
      await this.updateAuthToken();
    }
    await api.iadea.switch.post(`?access_token=${this.accessToken}`, {
      mode: 'home'
    });
  }

  /**
   * Get a new auth token
   * @return {Promise<void>}
   */
  async updateAuthToken() {
    const res = await api.iadea.auth.post('', {
      'grant_type': 'password',
      'username': 'admin',
      'password': ''
    });
    this.accessToken = (await res.json()).access_token;
  }
}

export default new PanelApiIadea();
